import globalEventBus from 'toxilibs/event_bus_queued.js'
import requestAnimationFrame from 'toxilibs/request_animation_frame_polyfill.js'

let eventBus = globalEventBus('renderer')

eventBus.on('world loaded',   startLoop)
eventBus.on('world unloaded', stopLoop)

let loopStarted = false


function startLoop () {
    if (!loopStarted) {
        loopStarted = true
        loop()
    }
}


function stopLoop () {
    loopStarted = false
}


function loop () {
    requestAnimationFrame(function () {
        eventBus.emit('new frame started')

        if (loopStarted) {
            loop()
        }
    })
}




